// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const HostsOffIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="HostsOffIcon" ref={forwardedRef} {...props}>
      <path d="M5.24 17H8.5v-1.5H6.74z" />
      <path d="M8.49 13.75h4.26a1 1 0 0 0 1-1V8.49l-1.5 1.5v2.26H9.99z" />
      <path d="m7.874 12.25-1.266 1.267A1 1 0 0 1 6.25 12.75v-5.5a1 1 0 0 1 1-1h5.5a1 1 0 0 1 .767.358L12.25 7.874V7.75h-4.5v4.5z" />
      <path d="M15.5 6.74V8.5H17V5.24z" />
      <path d="m17 3.124-1.5 1.5V4.5h-4V3H17z" />
      <path d="m4.624 15.5-1.5 1.5H3v-5.5h1.5v4z" />
      <path d="M8.5 3v1.5h-4v4H3V3z" />
      <path d="M15.5 11.5H17V17h-5.5v-1.5h4z" />
      <path d="M1.25 16.75 16.806 1.194l1.061 1.06L2.311 17.811z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const HostsOffIcon = /* @__PURE__ */ Object.assign(
  HostsOffIconComponent,
  { displayName: 'HostsOffIcon' },
);
